
import { useMemo } from 'react'
import { Card } from '@/components/ui/card'
import type { Tenant } from '@/lib/types'

interface TenantsStatsProps {
  tenants: Tenant[]
}

export function TenantsStats({ tenants }: TenantsStatsProps) {
  const stats = useMemo(() => {
    return {
      total: tenants.length,
      withLicense: tenants.filter((t: any) => t.licenseId).length,
      activePlans: tenants.filter((t: any) => t.tenantPlan?.billingStatus === 'active').length,
      enterprise: tenants.filter((t: any) =>
        t.tenantPlan?.planTier === 'enterprise' || (t as any).license?.plan === 'enterprise'
      ).length,
      trialPlans: tenants.filter((t: any) => t.tenantPlan?.billingStatus === 'trial').length,
    }
  }, [tenants])

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Total Tenants</span>
        <span className="text-2xl font-bold mt-2">{stats.total}</span>
        <p className="text-xs text-muted-foreground mt-1">
          {stats.withLicense} linked to licenses
        </p>
      </Card>

      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Active Plans</span>
        <span className="text-2xl font-bold mt-2 text-green-600 dark:text-green-400">{stats.activePlans}</span>
      </Card>

      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Enterprise</span>
        <span className="text-2xl font-bold mt-2 text-purple-600 dark:text-purple-400">{stats.enterprise}</span>
      </Card>

      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Trial Plans</span>
        <span className="text-2xl font-bold mt-2 text-blue-600 dark:text-blue-400">{stats.trialPlans}</span>
      </Card>
    </div>
  )
}
